import * as React from 'react'
import { Link } from '@tanstack/react-router'

import { dayjs } from '@/lib/dayjs'
import { cn } from '@/lib/utils'
import { CalendarEvent } from '@/features/calendar/types'

type YearViewProps = {
  currentDate: Date
  events?: CalendarEvent[]
}

export const YearView: React.FC<YearViewProps> = ({ currentDate, events }) => {
  const yearStart = dayjs(currentDate).startOf('year')
  const yearEnd = dayjs(currentDate).endOf('year')
  const months = []
  let month = yearStart
  while (month.isBefore(yearEnd) || month.isSame(yearEnd, 'month')) {
    months.push(month)
    month = month.add(1, 'month')
  }

  return (
    <div className="grid grid-cols-4 gap-4 border">
      {months.map((month) => (
        <Link
          key={month.toString()}
          className="bg-background hover:bg-secondary/100 rounded-lg p-2"
          to="/calendar"
          search={(searchParams) => ({
            ...searchParams,
            currentDate: month.toDate(),
            view: 'month',
          })}
        >
          <div className="mb-2 text-sm font-medium">{month.format('MMMM')}</div>
          <div className="grid grid-cols-7 gap-1 text-xs">
            {Array.from({ length: month.daysInMonth() }, (_, i) =>
              month.date(i + 1).tz('Europe/Rome')
            ).map((day) => (
              <div
                key={day.toString()}
                className={cn(
                  'flex size-6 items-center justify-center rounded-full',
                  day.isSame(dayjs(), 'day') &&
                    'bg-primary text-primary-foreground',
                  events?.some(
                    (event) =>
                      day.isSameOrAfter(dayjs.tz(event.start_date)) &&
                      day.isSameOrBefore(dayjs.tz(event.end_date))
                  ) && 'border-primary border'
                )}
              >
                {day.format('D')}
              </div>
            ))}
          </div>
        </Link>
      ))}
    </div>
  )
}
